import { render, staticRenderFns } from "./ButtonRound.vue?vue&type=template&id=1298562e&scoped=true&"
var script = {}
import style0 from "./ButtonRound.vue?vue&type=style&index=0&id=1298562e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298562e",
  null
  
)

export default component.exports